import { ActionType } from '../action-types/index'
import { NavActions } from '../actions/index'
import { NavState } from "../../models"

const initialNavState: NavState = {stack: []}

const navStateReducer = (state: NavState = initialNavState, action: NavActions) => {
    switch (action.type) {
        case ActionType.UpdateNavState:
            return state = action.payload
        case ActionType.ClearNavStack:
            return state = {stack: []}
        default:
            return state
    }
}

export default navStateReducer